const PRIMARY_COLOR = '#90348A';
const SECONDARY_COLOR = '#94378C';
const BACKGROUND_COLOR = '#F1F1F1';

const lightTheme = {
    primaryColor: PRIMARY_COLOR,
    secondaryColor: SECONDARY_COLOR,
    backgroundColor: BACKGROUND_COLOR,
}

export default lightTheme;